<template>
	<picker ref="picker"
		class="v5-citypicker"
		@on-select="handleSelect(arguments)"
		:data="cityData"
		:selected-index="selectedIndex"
		:title="title"
		@on-change="handleChange"
		:cancelTxt="cancelTxt"
		:confirmTxt="confirmTxt">
	</picker>
</template>

<script>
/**
 * @desc city-picker 组件
 * @param {string} [title] - picker 标题
 * @param {string} [cancelTxt] - 取消按钮
 * @param {string} [confirmTxt] - 确定按钮
 * @param {string} [data] - picker 数据
 * @param {string} [selectedIndex] - 选中数据
 */
import Picker from '../picker';

export default {
	name: 'CityPicker',
	props: {
		title: {
			type: String
		},
		cancelTxt: {
			type: String,
			default: '取消'
		},
		confirmTxt: {
			type: String,
			default: '确定'
		},
		data: {
			type: Array,
			default() {
				return [];
			}
		},
		selectedIndex: {
			type: Array,
			default() {
				return [0, 0, 0];
			}
		}
	},
	data() {
		return {
			tempIndex: this.selectedIndex.slice()
		};
	},
	watch: {
		cityData(val) {
			this.$refs.picker.refresh();
		}
	},
	methods: {
		show() {
			this.$refs.picker.setData(this.cityData);
			this.$refs.picker.show();
		},
		handleSelect(args) {
			this.$emit('on-select', ...args);
		},
		handleChange(i, newIndex) {
			if (newIndex !== this.tempIndex[i]) {
				this.tempIndex.splice(i, 1, newIndex);
				for (let j = this.tempIndex.length - 1; j > i; j--) {
					this.tempIndex.splice(j, 1, 0);
					setTimeout(() => {
						this.$refs.picker.scrollTo(j, 0);
					}, 80);
				}
			}
		}
	},
	computed: {
		/**
		 * 初始化当前显示城市
		 */
		cityData() {
			const [provinceList, cityList, areaList] = this.data;
			const provinces = provinceList;
			const cities = cityList[provinces[this.tempIndex[0]].value];
			if (this.data.length > 2) {
				const areas = areaList[cities[this.tempIndex[1]].value];
				return [provinces, cities, areas];
			}
			return [provinces, cities];
		}
	},
	components: {
		Picker
	}
};
</script>
